export default __webpack_public_path__ + "cf0a67aa3b94ce4253556fc9d7178a56.png";